import { ButtonStyle, IEntity, PageMode } from "../../../../../base/types"
import { IServiceRequest, ServiceRequestPaymentStage } from "../../models"
import { useCallback, useEffect } from "react"

import { IPageLink } from "../../../../../base/models"
import { NTTButton } from "../../../pg-integration/ntt/NTTButton"
import { PayTmButton } from "../../../pg-integration/paytm/PayTmButton"
import { PayUButton } from "../../../pg-integration/payu/PayUButton"
import { RazorPayButton } from "../../../pg-integration/razor-pay/RazorPayButton"
import clsx from "clsx"
import { useAuth } from "../../../../../../modules/auth"
import { useFormikContext } from "formik"
import { usePageContext } from "../../../../page/context"
import { useServiceRequestContext } from "../../service-request"

// import { NTTButton, PayTmButton, PayUButton, RazorPayButton } from "../../../pg-integration"













export const MoneyAttribute = ({
    attributeId,
    value,
    className,
    onChange,
    onBlur,
}: {
    attributeId: string,
    value?: string,
    required?: boolean,
    placeholder?: string,
    readOnly?: boolean,
    className?: string,
    onChange: (value: any) => void,
    onBlur: () => void
}) => {
    const { page } = usePageContext()
    const { user } = useAuth()
    const { entity, result } = useServiceRequestContext();
    const { service, serviceRequest } = result || {}
    const { setFieldValue } = useFormikContext<IEntity>() || {}

    const currency = "INR";

    useEffect(() => {
        if (!attributeId) return;

        const fieldError = isChecklistValid()
        if (fieldError) {
            setFieldValue(attributeId, false)
        } else {
            setFieldValue(attributeId, "")
        }
        // eslint-disable-next-line
    }, [serviceRequest])

    const isChecklistValid = useCallback(() => {
        if (!serviceRequest)
            return;

        if (serviceRequest.paymentStage !== ServiceRequestPaymentStage.Completed) {
            return "Payment is not completed.";
        }

        // eslint-disable-next-line
    }, [serviceRequest])

    if (!user || !service || !serviceRequest || !service.paidService || !page) {
        return <></>
    }

    const amount = service.amount || 0;
    const orderNo = serviceRequest.requestNumber;
    const successPage: IPageLink = { pageId: page.id, systemId: serviceRequest.id, pageMode: PageMode.View }
    const failedPage: IPageLink = { pageId: page.id, systemId: serviceRequest.id, pageMode: PageMode.View }

    if (serviceRequest.paymentStage && serviceRequest.paymentStage !== ServiceRequestPaymentStage.Failed) {
        return <PaymentStatus
            serviceRequest={serviceRequest}
            className={className}
            amount={amount} />
    }

    return <>
        <div className={clsx(className, "d-flex flex-column gap-1 my-5")}>
            <div className="flex-fill fs-6 fw-semibold text-gray-600">
                Pay <span className="fs-2 fw-bolder text-gray-800">{formatMoney(amount)}</span> with:
            </div>
            <div className="flex-fill d-flex flex-wrap align-items-stretch gap-2">
                <PayTmButton
                    className="border border-primary min-w-150px min-h-50px"
                    style={ButtonStyle.OutlinePrimary}
                    enrolmentNo={user.userName}
                    orderNo={orderNo}
                    entity={entity}
                    entityId={serviceRequest.id}
                    firstName={user.firstName || user.userName}
                    lastName={user.lastName}
                    email={user.email}
                    phoneNumber={user.phoneNumber}
                    successPage={successPage}
                    failedPage={failedPage}
                    amount={amount}
                    currency={currency} />

                <PayUButton
                    className="border border-primary min-w-150px min-h-50px"
                    style={ButtonStyle.OutlinePrimary}
                    enrolmentNo={user.userName}
                    orderNo={orderNo}
                    entity={entity}
                    entityId={serviceRequest.id}
                    firstName={user.firstName || user.userName}
                    lastName={user.lastName}
                    email={user.email}
                    phoneNumber={user.phoneNumber}
                    successPage={successPage}
                    failedPage={failedPage}
                    amount={amount}
                    currency={currency} />

                <RazorPayButton
                    className="border border-primary min-w-150px min-h-50px"
                    style={ButtonStyle.OutlinePrimary}
                    enrolmentNo={user.userName}
                    orderNo={orderNo}
                    entity={entity}
                    entityId={serviceRequest.id}
                    firstName={user.firstName || user.userName}
                    lastName={user.lastName}
                    email={user.email}
                    phoneNumber={user.phoneNumber}
                    successPage={successPage}
                    failedPage={failedPage}
                    amount={amount}
                    currency={currency} />

                <NTTButton
                    className="border border-primary min-w-150px min-h-50px"
                    style={ButtonStyle.OutlinePrimary}
                    enrolmentNo={user.userName}
                    orderNo={orderNo}
                    entity={entity}
                    entityId={serviceRequest.id}
                    firstName={user.firstName || user.userName}
                    lastName={user.lastName}
                    email={user.email}
                    phoneNumber={user.phoneNumber}
                    successPage={successPage}
                    failedPage={failedPage}
                    amount={amount}
                    currency={currency} />
            </div>
        </div>
    </>
}

const PaymentStatus = ({ serviceRequest, amount, className }: {
    serviceRequest: IServiceRequest,
    amount: number,
    className?: string,
}) => {
    const getStatus = () => {
        switch (serviceRequest.paymentStage) {
            case ServiceRequestPaymentStage.Completed:
                return "Payment Received.";
            case ServiceRequestPaymentStage.OnGoing:
            case ServiceRequestPaymentStage.Pending:
                return "Waiting for confirmation from the bank.";
        }
    }

    return <>
        <div className={clsx(className, "d-flex align-items-center gap-1")}>
            <span className="fs-2 fw-bolder text-gray-800">{formatMoney(amount)}</span>
            <div><span className="badge badge-info">{getStatus()}</span></div>
        </div>
    </>
}

const formatMoney = (number?: number | string) => {
    if (!number) number = 0;

    if (typeof number !== 'number') {
        number = Number(number)
    }

    const formatter = new Intl.NumberFormat(navigator.language, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return formatter.format(number);
}
